module.exports = __webpack_public_path__ + "img/futurama-bender.bbfcc417.png";